export default "__VITE_ASSET__Mu5856zQ__"